export enum ConfigMasterConstants {
    /* security related [NOT IN USE] */
    USER_DEFAULT_EXPIRY_PERIOD = 'USER_DEFAULT_EXPIRY_PERIOD',
    CHECK_USER_PASSWORD_EXPIRY = 'CHECK_USER_PASSWORD_EXPIRY',
    IS_2FA_ACTIVE = 'IS_2FA_ACTIVE',
    IS_EMAIL_GATEWAY_ACTIVE = 'IS_EMAIL_GATEWAY_ACTIVE',
    MAX_LOGIN_ATTEMPT_COUNT = 'MAX_LOGIN_ATTEMPT_COUNT',
    MAX_USER_LOCK_TIME_HRS = 'MAX_USER_LOCK_TIME_HRS',

    /* [IN USE] */
    MAX_KEY_FOB_RANGE = 'MAX_KEY_FOB_RANGE',
    LOGO_IMAGE_PATH = 'LOGO_IMAGE_PATH',
    HEADER_TEXT = 'HEADER_TEXT',
    FOOTER_TEXT = 'FOOTER_TEXT',
    PRIMARY_COLOR = 'PRIMARY_COLOR',
    SECONDARY_COLOR = 'SECONDARY_COLOR',
    DEFAULT_PAGE_SIZE = 'DEFAULT_PAGE_SIZE',
    PAGE_SIZE_OPTIONS = 'PAGE_SIZE_OPTIONS',
    IS_FCM_ACTIVE = 'IS_FCM_ACTIVE',
    IS_SMS_GATEWAY_ACTIVE = 'IS_SMS_GATEWAY_ACTIVE',
    MINS_BEFORE_SENDING_SCHEDULED_RETRIEVAL_REQ_PLC = 'MINS_BEFORE_SENDING_SCHEDULED_RETRIEVAL_REQ_PLC',
    MINS_BEFORE_SENDING_SCHEDULED_RETRIEVAL_REQ_NOTIF = 'MINS_BEFORE_SENDING_SCHEDULED_RETRIEVAL_REQ_NOTIF',
    MINS_BEFORE_SENDING_SCHEDULED_BOOKING_REQ_PLC = 'MINS_BEFORE_SENDING_SCHEDULED_BOOKING_REQ_PLC',
    MINS_BEFORE_SENDING_NOTIF = 'MINS_BEFORE_SENDING_NOTIF',
    SEE_NO_OF_FUTURE_NOTIF = 'SEE_NO_OF_FUTURE_NOTIF',
    DIFF_BETWEEN_TIME_TO_RESYNC_PARKING_MAP = 'DIFF_BETWEEN_TIME_TO_RESYNC_PARKING_MAP',
    DIFF_BETWEEN_TIME_TO_TELL_GW_INACTIVE = 'DIFF_BETWEEN_TIME_TO_TELL_GW_INACTIVE'
}
